/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useState } from "react";
import IAppHelpContext from "./IAppHelpContext";

export default class AppMenuContextInstance implements IAppHelpContext {
    private readonly _isKontaktformularDialogOpen: boolean;
    private readonly _setIsKontaktformularDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;

    public constructor() {
        [this._isKontaktformularDialogOpen, this._setIsKontaktformularDialogOpen] = useState<boolean>(false);
    }

    public get isKontaktformularDialogOpen() {
        return this._isKontaktformularDialogOpen;
    }

    public setIsKontaktformularDialogOpen(isOpen: boolean) {
        this._setIsKontaktformularDialogOpen(isOpen);
    }
}